import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { Heading, InputNumber } from '@warrenbrasil/nebraska-web';

interface Props {
  leftTitle?: string;
  rightTitle?: string;
  leftValue?: number;
  rightValue?: number;
  min?: number;
  max?: number;
  step?: number;
}

interface Emits {
  (e: 'update:leftValue', value: number): void;
  (e: 'update:rightValue', value: number): void;
  (e: 'change', payload: { left: number; right: number }): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DoubleSliderFilter',
  props: {
    leftTitle: { default: '' },
    rightTitle: { default: '' },
    leftValue: { default: undefined },
    rightValue: { default: undefined },
    min: { default: 0 },
    max: { default: 100 },
    step: { default: 1 }
  },
  emits: ["update:leftValue", "update:rightValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:leftValue', value: number): void;
  (e: 'update:rightValue', value: number): void;
  (e: 'change', payload: { left: number; right: number }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { leftTitle: string, rightTitle: string, leftValue: number, rightValue: number, min: number, max: number, step: number };





const leftValueInternal = ref<number | undefined>(props.leftValue ?? undefined);
const rightValueInternal = ref<number | undefined>(
  props.rightValue ?? undefined
);

watch(
  () => props.leftValue,
  v => (leftValueInternal.value = v)
);
watch(
  () => props.rightValue,
  v => (rightValueInternal.value = v)
);

watch(leftValueInternal, val => {
  emit('update:leftValue', val as number);
  emit('change', {
    left: val as number,
    right: rightValueInternal.value as number
  });
});

watch(rightValueInternal, val => {
  emit('update:rightValue', val as number);
  emit('change', {
    left: leftValueInternal.value as number,
    right: val as number
  });
});

return { __sfc: true,props, emit, leftValueInternal, rightValueInternal, Heading, InputNumber }
}

})